<template>
  <div class="container text-center py-5">
    <div v-show="isLoading" class="loader-container">
      <div ref="lottieLoader" class="lottie-animation"></div>
  <p class="loader-text">Cargando...</p>
</div>
    <!-- Imagen de líneas SVG con animación -->

    <div ref="bienvenidaRef" id="album" class="card shadow-lg p-4 bg-light upload-container">
      <div class="mb-3">
        <img src="@/assets/camara.png" alt="Bienvenida" class="img-fluid gif-pequeno">
      </div>

      <h4 class="titulo">Álbum de Fotos </h4><br>

      <p class="text-muted">Sube las fotografías del evento aquí</p>

      <!-- Área de subida de fotos con diseño atractivo -->
      <label for="inputFile" class="upload-area">
        <i class="fas fa-camera-retro upload-icon"></i>
        <span class="custom-file-upload"> Selecciona imágenes</span>
      </label>

      <input 
        id="inputFile"
        ref="fileInput"
        type="file"
        name="fotos"
        class="file-input"
        accept="image/*"
        multiple
        @change="validateFiles"
      >


   

      <p v-if="errorMessage" class="text-danger">{{ errorMessage }}</p>

      <!-- Vista previa de imágenes -->
      <div v-if="previewImages.length > 0" class="preview-container">
        <h5 class="text-secondary mt-3">Vista previa:</h5>
        <div class="preview-grid">
          <div v-for="(src, index) in previewImages" :key="index" class="preview-item">
            <img :src="src" alt="Vista previa" class="preview-image">
            <button class="delete-btn" @click="removeImage(index)">
              <i class="fas fa-trash-alt"></i>
            </button>
          </div>
        </div>
      </div>

  <!-- Botón personalizado -->
  <button class="upload-btn" @click="confirmUpload">
      <i class="fas fa-cloud-upload-alt"></i> Subir Fotos
    </button>
      <p class="text-muted mt-3">No olvides dar clic en "Subir fotos" después de revisar tus imágenes.</p>

      <p v-if="photoUploaded" class="mensaje-gracias">¡Gracias por compartir tus fotos con nosotros!</p>
    </div>
  </div>
</template>

<script>
import { ref, watch, onMounted, nextTick } from 'vue';
import axios from 'axios';
import baseUrl from '../api';
import Swal from 'sweetalert2';
import lottie from 'lottie-web';
import heartAnimation from '../assets/heart.json';

export default {
  name: 'hashtag-etiqueta',
  props: {
    idInvitado: {
      type: Number,
      required: true,
      validator(value) {
        return !isNaN(value) && value > 0;
      }
    },
    nombre: {
      type: String,
      default: '',
    },
    idFestejado: {
      type: Number,
      default: null,
    }
  },

  
  setup(props) {
    const errorMessage = ref('');
    const fileInput = ref(null);
    const selectedFiles = ref([]);
    const previewImages = ref([]);
    const photoUploaded = ref(false);
    const isLoading = ref(false);
    const lottieLoader = ref(null);
    const MAX_FILES = 10;
    const bienvenidaRef = ref(null);
    onMounted(() => {
  nextTick(() => {
    // Espera a que el DOM esté listo y no haya portada bloqueando
    setTimeout(() => {
      if (window.location.hash === '#album' && bienvenidaRef.value) {
        const offset = 100; // Ajusta según altura de encabezados fijos
        const top = bienvenidaRef.value.getBoundingClientRect().top + window.scrollY - offset;

        window.scrollTo({
          top,
          behavior: 'smooth'
        });
      }
    }, 1000); // Aumentado el delay para esperar portada
  });
});



 // ✅ Cargar Lottie SOLO cuando `isLoading` cambia a `true`
 watch(isLoading, (newVal) => {
      if (newVal && lottieLoader.value) {
        console.log("🎬 Cargando animación Lottie...");
        lottie.loadAnimation({
          container: lottieLoader.value,
          renderer: 'svg',
          loop: true,
          autoplay: true,
          animationData: heartAnimation
        });
      }
    });

    const validateFiles = (event) => {
  const files = Array.from(event.target.files);
  
  if (files.length === 0) {
    errorMessage.value = 'Por favor, selecciona al menos una imagen.';
    return;
  }

  if (files.length > MAX_FILES) {
    Swal.fire('Límite excedido', `Solo puedes subir un máximo de ${MAX_FILES} imágenes.`, 'warning');
    event.target.value = ''; 
    return;
  }
  
  const invalidFiles = files.filter(file => !file.type.startsWith('image'));
  if (invalidFiles.length > 0) {
    errorMessage.value = 'Por favor, selecciona solo archivos de imagen (JPG, PNG, GIF).';
    event.target.value = ''; // Limpia el input
    selectedFiles.value = [];
    previewImages.value = [];
  } else {
    errorMessage.value = '';
    selectedFiles.value = files;
    previewImages.value = selectedFiles.value.map(file => URL.createObjectURL(file));
  }
};


    const removeImage = (index) => {
      selectedFiles.value.splice(index, 1);
      previewImages.value.splice(index, 1);
    };

    const confirmUpload = async () => {
      if (selectedFiles.value.length === 0) {
        errorMessage.value = 'Por favor, selecciona al menos una imagen.';
        return;
      }

      Swal.fire({
        title: 'Revisa tus fotos',
        text: 'Revisa la vista previa de las fotos antes de subirlas. Una vez que estés seguro(a), da clic en "Subir fotos".',
        icon: 'info',
        showCancelButton: true,
        confirmButtonText: 'Subir fotos',
        cancelButtonText: 'Cancelar',
      }).then((result) => {
        if (result.isConfirmed) {
          uploadPhotos();
        }
      });
    };
    const uploadPhotos = async () => {
      console.log("🟢 Antes de activar loader:", isLoading.value);

      isLoading.value = true; // Activar el loader
      console.log("🟢 despues de activar loader:", isLoading.value);

  const formData = new FormData();
  selectedFiles.value.forEach(file => {
    formData.append('fotos', file);
  });

  formData.append('idFestejada', props.idFestejado);
  formData.append('idInvitado', props.idInvitado || null);

  // 🔍 Verificamos si las props tienen valores antes de construir la URL
  console.log("➡️ Valores recibidos en props:");
  console.log("🔹 Nombre:", props.nombre);
  console.log("🔹 idFestejado:", props.idFestejado);
  console.log("🔹 idInvitado:", props.idInvitado);

  try {
    // 🔍 Validar que los valores existan antes de armar la URL
    if (!props.nombre && !props.idFestejado && !props.idInvitado) {
      console.error(" ERROR: No se recibieron parámetros válidos.");
      return;
    }

    // 🔹 Construcción segura de la URL
    const params = [];
    if (props.nombre) params.push(encodeURIComponent(props.nombre));
    if (props.idFestejado) params.push(props.idFestejado);
    if (props.idInvitado) params.push(props.idInvitado);

    const paqueteUrl = `${baseUrl}/subirfotos/${params.join('/')}`;

    // 📌 Mostrar la URL final antes de enviar la petición
    console.log(" URL para subir fotos:", paqueteUrl);

    // 🔥 Verificamos qué se está enviando en formData
    for (let [key, value] of formData.entries()) {
      console.log(` FormData -> ${key}:`, value);
    }

    // 🔥 Hacemos la petición POST con Axios
    const response = await axios.post(paqueteUrl, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });

    console.log(" Respuesta del servidor:", response.data);

    if (response.data.success) {
      Swal.fire('¡Éxito!', 'Tus fotos se han subido correctamente.', 'success');
      photoUploaded.value = true;
      previewImages.value = [];
      selectedFiles.value = [];
      fileInput.value.value = '';  // Limpiar el input después de subir las fotos
    } else {
      Swal.fire('Error', 'Hubo un problema al subir las fotos.', 'error');
    }
  } catch (error) {
    console.error('Error al subir las fotos:', error);
    console.error(' Código de error:', error.code);
    console.error(' Respuesta del servidor:', error.response ? error.response.data : "No hay respuesta");

    Swal.fire('Error', 'Hubo un problema al subir las fotos.', 'error');
  }finally {
    isLoading.value = false; // Desactivar el loader después de la respuesta
  }
};



    return { 
      errorMessage, 
      fileInput, 
      confirmUpload, 
      validateFiles, 
      photoUploaded, 
      bienvenidaRef,

      previewImages, 
      removeImage ,isLoading, lottieLoader 
    };
  }
};
</script>
  
  <style>

.container{
  min-height: auto;
  height: auto;
  background: transparent !important;
  padding: 10px 0;
  margin: 0;
  margin-top:-100px;
  margin-bottom: -100px;
}

/* SVG DECORATIVO */

.decorative-svg {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 45%;
  height: auto;
  margin-bottom: 8px;
  opacity: .9;
}

/* TÍTULO */

.titulo{
  font-family:'Playfair Display', serif;
  font-size: 28px !important;
  color: #b08a5a;
  margin-bottom: 10px;
}

/* CONTENEDOR */

.upload-container {
  background: transparent !important;
  max-width: auto;
  margin: auto;
  border-radius: 15px;
  padding: 0;
}

/* ÁREA DE SUBIDA */

.upload-area {
  border: 2px dashed #8e6f49;
  padding: 14px;
  text-align: center;
  cursor: pointer;
  border-radius: 12px;
  transition: all 0.3s ease;
  background: transparent !important;
}

.upload-area:hover {
  background: rgba(176, 138, 90, 0.06);
}

/* ÍCONO */

.upload-icon {
  font-size: 34px;
  color: #8e6f49;
  margin-bottom: 6px;
}

/* PREVIEW */

.preview-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: center;
  margin-top: 10px;
}

.preview-item {
  position: relative;
  width: 90px;
  height: 90px;
  border-radius: 10px;
  overflow: hidden;
}

.preview-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 10px;
}

/* BOTÓN ELIMINAR */

.delete-btn {
  position: absolute;
  top: 4px;
  right: 4px;
  background: rgba(255, 0, 0, 0.9);
  color: white;
  border: none;
  border-radius: 50%;
  width: 18px;
  height: 18px;
  cursor: pointer;
  font-size: 11px;
}

/* GIF */

.gif-pequeno {
  width: 42px;
  height: auto;
}

/* INPUT */

.file-input {
  background-color: transparent;
  color: transparent;
  border: none;
  width: 100px;
  height: 28px;
  opacity: 0.01;
}

/* BOTÓN */

.upload-btn {
  background-color: #b08a5a;
  color: white;
  font-size: 15px;
  font-weight: bold;
  padding: 10px 18px;
  justify-content: center;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  box-shadow: 0px 4px 10px rgba(176, 138, 90, 0.18);
}

.upload-btn:hover {
  background: linear-gradient(
    135deg,
    rgba(48, 73, 93, 1),
    rgba(74, 93, 107, 1)
  );

  box-shadow:
  0px 6px 15px rgba(176, 138, 90, 0.35);

  transform: translateY(-2px);
}

.upload-btn i {
  font-size: 18px;
}

/* LOADER */

.loader-container {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  z-index: 10000 !important;

  width: 100vw;
  height: 100vh;

  background: rgba(0, 0, 0, 0.55);

  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

/* LOTTIE */

.lottie-animation {
  width: 120px;
  height: 120px;
}

/* TEXTO */

.loader-text {
  color: white;
  font-size: 18px;
  font-weight: bold;
  font-family: 'Dancing Script', cursive;
  margin-top: 10px;
}

</style>